import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { SidebarProvider } from './SidebarContext';
import './LayoutComponents.css';

const Footer = () => {
  const { t } = useTranslation();
  return <footer className="footer">{t('layout.footer')}</footer>;
};

const Layout = ({ onLogout }) => {
  return (
    <SidebarProvider>
      <div className="layout-container">
        <Sidebar />
        <div className="layout-main-content">
          <Navbar onLogout={onLogout} />
          <div className="layout-content-area">
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Layout;
